import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import MenuItem from "@mui/material/MenuItem";

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";
import { Helmet } from "react-helmet-async";
import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";
import { blockUserFromPartnerAction } from "../../redux/toolkit/publisherUser/blockUserFromPartner";
import SnackBarUI from "../../comman/SnackBarUI";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";
import { set } from "lodash";
import CheckIcon from "@mui/icons-material/Check";
import { getUserAction } from "../../redux/toolkit/users/getAdminSupports";

const partnerSchema = yup
  .object({
    partner: yup.string().required("Partner Name is required"),
    reason: yup.string().required("Please Enter The Reason"),
  })
  .required();

const BlockUserFromPartner = ({ state, setState, userData }) => {
  const {
    register,
    setValue,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(partnerSchema) });

  const dispatch = useDispatch();
  const [snack, setSnack] = useState(false);

  const partnerDetails = useSelector((state) => state.allPartnerWithoutLimit);
  const blockUserFromPartner = useSelector(
    (state) => state.blockUserFromPartner
  );
  const { loading: blockUserLoading, status, message } = blockUserFromPartner;
  const [partner, setPartner] = useState("");
  const [reason, setReason] = useState("");
  const { loading } = partnerDetails;
  const [alert, setAlert] = useState(false);

  const handleBlockUserFromPartner = async () => {
    if (!partner) {
      setAlert(true);
      return;
    }
    // setAlert(false);

    const blockUser = await dispatch(
      blockUserFromPartnerAction({
        //   p_user_id: userData?.p_user_id,
        // publisher_id: userData?.publisher_id,
        user_id: userData?.id,
        email: userData?.email,
        partner: partner,
      })
    );

    setTimeout(() => {
      setState(false);

      if (blockUser?.payload?.status == 200) {
        dispatch(
          getUserAction({
            is_block: false,
            // page: pageState.page,
            // limit: pageState.pageSize,
          })
        );
      }
    }, 1000);
    setSnack(true);
  };

  const handleClose = () => {
    setState(false);
  };

  const handleChange = (event) => {
    setPartner(event.target.value);
  };

  useEffect(() => {
    dispatch(getAllPartnerActionNoLimit({}));
  }, []);

  return (
    <>
      <Body>
        <Modal sx={{ overflow: "scroll" }} open={state} onClose={handleClose}>
          <Box className="modal_box">
            <Card sx={{ width: 500, p: 5 }}>
              <Typography variant="h5" sx={{ mb: 5 }} align="center">
                Block User From Partner
              </Typography>

              {/* <form
                sx={{ height: "auto" }}
                onSubmit={handleSubmit(handleBlockUserFromPartner)}
              > */}
              <Box
                component="form"
                sx={{ height: "auto" }}
                onSubmit={handleSubmit(handleBlockUserFromPartner)}
              >
                <Box sx={{ minWidth: 120, marginBottom: "20px" }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Select Partner
                    </InputLabel> 
                    
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={partner}
                      label="Select Partner"
                      onChange={handleChange}
                    >
                      {partnerDetails?.data?.map((item) => {
                        return (
                          <MenuItem value={item._id}>{item.name}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>

                {/* <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Enter Reason"
                      variant="outlined"
                      placeholder="Enter Reason"
                      onChange={(e) => setReason(e.target.value)}
                    />
                  </Grid>
                </Grid> */}

                <Stack direction="row" spacing={2} mt={3}>
                  <Button
                    sx={{ zIndex: 1000 }}
                    variant="contained"
                    type="submit"
                    disabled={loading}
                    onClick={() => {
                      handleBlockUserFromPartner();
                    }}
                  >
                    {loading ? <CircularProgress /> : "Block User"}
                  </Button>

                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </Stack>
                {/* </form> */}
              </Box> 
            </Card>
          </Box>
        </Modal>

        <SnackBarUI
          state={snack}
          setState={setSnack}
          status={status}
          message={message}
        />
      </Body>
    </>
  );
};

export default BlockUserFromPartner;
